// extracted by mini-css-extract-plugin
export var accountDetailsSection = "PartnerShippingAddressPage-module__accountDetailsSection___j8Znf";
export var actions = "PartnerShippingAddressPage-module__actions___dfokl";
export var detailsGrid = "PartnerShippingAddressPage-module__detailsGrid___g7q8g";
export var error = "PartnerShippingAddressPage-module__error___TEOyl";
export var field = "PartnerShippingAddressPage-module__field___f1JRa";
export var form = "PartnerShippingAddressPage-module__form___P33BT";
export var formCard = "PartnerShippingAddressPage-module__formCard___0DhTV";
export var pageHeader = "PartnerShippingAddressPage-module__pageHeader___HAPtp";
export var requiredMark = "PartnerShippingAddressPage-module__requiredMark___EqGpg";